if (!customElements.get('veyra-purchase-consent')) {
  customElements.define(
    'veyra-purchase-consent',
    class VeyraPurchaseConsent extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.dialog = this.querySelector('[data-vy-consent-dialog]');
        this.policyConsent = this.querySelector('[data-vy-policy-consent]');
        this.actionButtons = [...this.querySelectorAll('[data-vy-consent-destination]')];
        this.error = this.querySelector('[data-vy-consent-error]');
        this.productTitle = this.querySelector('[data-vy-consent-product-title]');
        this.productImage = this.querySelector('[data-vy-consent-product-image]');
        this.lastFocusedElement = null;

        this.querySelectorAll('[data-vy-consent-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog?.addEventListener('close', () => this.unlockPage());
        this.policyConsent?.addEventListener('change', () => this.updateConsentState());

        this.actionButtons.forEach((button) => {
          button.addEventListener('click', () => this.saveConsentAndContinue(button));
        });
      }

      openConfirmation(item = {}) {
        document.querySelector('cart-notification')?.close?.();
        document.querySelector('cart-drawer')?.close?.();

        const title = item.product_title || item.title || this.dataset.fallbackTitle || 'Serviço selecionado';
        const imageUrl = item.featured_image?.url || item.image || '';
        const imageAlt = item.featured_image?.alt || title;

        if (this.productTitle) this.productTitle.textContent = title;
        if (this.productImage) {
          if (imageUrl) {
            this.productImage.src = imageUrl;
            this.productImage.alt = imageAlt;
            this.productImage.hidden = false;
          } else {
            this.productImage.hidden = true;
            this.productImage.removeAttribute('src');
          }
        }

        if (this.policyConsent) this.policyConsent.checked = false;
        if (this.error) {
          this.error.hidden = true;
          this.error.textContent = this.error.dataset.defaultMessage;
        }
        this.updateConsentState();
        this.open();
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.lastFocusedElement = document.activeElement;
        document.body.classList.add('vy-consent-open');
        this.dialog.showModal();
        this.querySelector('[data-vy-consent-close]')?.focus();
      }

      close() {
        if (!this.dialog?.open) return;
        this.dialog.close();
        this.lastFocusedElement?.focus?.();
      }

      unlockPage() {
        document.body.classList.remove('vy-consent-open');
      }

      updateConsentState() {
        const accepted = Boolean(this.policyConsent?.checked);
        this.actionButtons.forEach((button) => {
          button.disabled = !accepted;
          button.setAttribute('aria-disabled', String(!accepted));
        });
        if (accepted && this.error) this.error.hidden = true;
      }

      async saveConsentAndContinue(button) {
        if (!this.policyConsent?.checked) {
          if (this.error) {
            this.error.hidden = false;
            this.error.setAttribute('tabindex', '-1');
            this.error.focus();
          }
          return;
        }

        this.actionButtons.forEach((item) => (item.disabled = true));
        const acceptedAt = new Date().toISOString();

        try {
          const response = await fetch(window.routes.cart_update_url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                'Aceitação dos termos e privacidade': `Aceite — ${acceptedAt}`,
                'Confirmação de maioridade': `Sim — ${acceptedAt}`,
              },
            }),
          });

          if (!response.ok) throw new Error('Consent update failed');
          window.location.assign(button.dataset.vyConsentDestination);
        } catch (error) {
          if (this.error) {
            this.error.textContent = 'Não foi possível guardar a confirmação. Tente novamente.';
            this.error.hidden = false;
          }
          this.updateConsentState();
        }
      }
    }
  );
}

function updateVeyraCartConsent(container) {
  if (!container) return;
  const policy = container.querySelector('[data-vy-cart-policy-consent]');
  const scope = container.closest('.cart__blocks, .drawer__inner, cart-notification') || document;
  const checkoutButtons = scope.querySelectorAll('[data-vy-consent-checkout], button[name="checkout"]');
  const accepted = Boolean(policy?.checked);

  checkoutButtons.forEach((button) => {
    button.disabled = !accepted;
    button.setAttribute('aria-disabled', String(!accepted));
  });

  if (accepted) container.querySelector('[data-vy-cart-consent-error]')?.setAttribute('hidden', '');
}

function initializeVeyraCartConsent(root = document) {
  root.querySelectorAll?.('[data-vy-cart-consent]').forEach((container) => updateVeyraCartConsent(container));
}

document.addEventListener('change', (event) => {
  const container = event.target.closest?.('[data-vy-cart-consent]');
  if (container) updateVeyraCartConsent(container);
});

document.addEventListener(
  'click',
  (event) => {
    const checkoutButton = event.target.closest?.('[data-vy-consent-checkout], button[name="checkout"]');
    if (!checkoutButton) return;
    const scope = checkoutButton.closest('.cart__blocks, .drawer__inner, cart-notification') || document;
    const container = scope.querySelector('[data-vy-cart-consent]');
    if (!container) return;

    const accepted = container.querySelector('[data-vy-cart-policy-consent]')?.checked;
    if (accepted) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const error = container.querySelector('[data-vy-cart-consent-error]');
    if (error) {
      error.hidden = false;
      error.setAttribute('tabindex', '-1');
      error.focus();
    }
  },
  true
);

document.addEventListener('DOMContentLoaded', () => initializeVeyraCartConsent());

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    window.setTimeout(() => initializeVeyraCartConsent(), 120);
  });
}
